<template>
  <v-container>
    <h1 class="mb-5">Logg inn</h1>

    <v-form ref="form" lazy-validation @submit.prevent="submit">
      <v-card class="orange lighten-5" elevation="3">
        <v-card-title class="white--text orange"> Logg inn </v-card-title>
        <v-container>
          <v-row>
            <v-col>
              <v-alert v-if="authFailed" type="error">
                Innlogging ikke vellykket, feil brukernavn eller passord.
              </v-alert>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <v-text-field
                v-model="username"
                :rules="[rules.required]"
                prepend-icon="mdi-account"
                label="Brukernavn"
                required
                :disabled="isSaving"
                @change="authFailed = false"
              ></v-text-field>
            </v-col>

            <v-col>
              <v-text-field
                v-model="password"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                prepend-icon="mdi-lock"
                :type="showPassword ? 'text' : 'password'"
                :rules="[rules.required]"
                label="Passord"
                required
                :disabled="isSaving"
                @click:append="showPassword = !showPassword"
                @change="authFailed = false"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>

        <v-card-actions>
          <v-btn type="submit" color="success" :loading="isSaving">
            <v-icon left> mdi-login </v-icon>
            Logg inn
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-container>
</template>

<script>
export default {
  name: "Login",

  data: function () {
    return {
      username: "",
      password: "",
      isSaving: false,
      authFailed: false,
      showPassword: false,
      rules: {
        required: (v) => !!v || "Required",
      },
    };
  },

  methods: {
    async submit() {
      if (this.$refs.form.validate()) {
        await this.$store.dispatch("login", {
          username: this.username,
          password: this.password,
        });

        if (!this.$store.state.auth.anonymous) {
          this.$router.push({
            name: "admin",
          });
        } else {
          this.authFailed = true;
        }
      }
    },
  },
};
</script>
